var a = Math.log,
  t = Math.log1p || function (t) {
    var o = +t;
    return o > -.00000001 && o < 1e-8 ? o - o * o / 2 : a(1 + o);
  };
export { t as m };